export default "__VITE_ASSET__b45f063f__"